import React from 'react';
import PropTypes from 'prop-types';
import BookingStep from './BookingStep';
import ExtraService from './ExtraService';
import Translate from './Translate';
import ExtraServicesHOC from '../hoc/ExtraServicesHOC';
import ExtraServiceCleaning from './ExtraServiceCleaning';
import validatorFinalCleaning from '../validation/servicesValidator';
import { errorstype, servicestype } from '../types/importtypes';
import errors from '../types/errors';
const ExtraServices = ({
  rental,
  children,
  errors,
  onChange,
  salesMarket,
  selectedFinalCleaning,
  services,
  stepIndex,
  stepTotal,
  validateFinalCleaning,
}) => {

  const hasService = (srvID) => services.findIndex(
    service => service.serviceId === srvID
  );

  // Has both Sicherheitspaket and SicherheitspaketPlus
  const hasBothSecurityPackages = !!(hasService('1001') && hasService('1102') !== -1);

  const extraServicesItems = services.map((extraService, index) => {

    if (validatorFinalCleaning(extraService)) {
      return (
        <ExtraServiceCleaning
          extraService={extraService}
          inputChange={onChange}
          key={index}
          selectedFinalCleaning={selectedFinalCleaning}
          showError={errors.finalCleaning}
          validateFinalCleaning={validateFinalCleaning}
        />
      );
    }

    if (extraService.serviceId == 1200 && extraService.serviceGroup == 202) {
      return <></>
    }

    return (
      <ExtraService
        rental={rental}
        extraService={extraService}
        hideBorderSecurityServiceGroup={hasBothSecurityPackages}
        inputChange={onChange}
        key={index}
        salesMarket={salesMarket}
      />
    );

  });

  return (
    <section className="booking-step booking-options card" id="booking-options">
      <div className="booking-step__inner">
        <div className="booking-step__inner2">
          <h2 className="card__header">
            <span className="card__header-prefix">
              {stepIndex}
              /
              {stepTotal}
            </span>
            <Translate content="Options" />
          </h2>
          <section className="card__body" id="ExtraServices">
            <div className="service-list">
              {extraServicesItems}
            </div>
          </section>
          {children}
        </div>
      </div>
    </section>
  );
};

ExtraServices.shouldComponentUpdate = () => true;
ExtraServices.PropTypes = {
  rental:PropTypes.object.isRequired,
  children:PropTypes.node,
  errors: errors,
  onChange:PropTypes.func.isRequired,
  salesMarket: PropTypes.string.isRequired,
  selectedFinalCleaning:PropTypes.bool.isRequired,
  services:PropTypes.arrayOf(
    servicestype.propTypes,
  ),
  stepIndex:PropTypes.number.isRequired,
  stepTotal:PropTypes.number.isRequired,
  validateFinalCleaning:PropTypes.func.isRequired,
};

export default ExtraServicesHOC(BookingStep(ExtraServices));
